import styled from 'src/styles/theme';
import { ModalFindDealerStyled } from '../ModalFindDealerStyled';
export const ModalFindDealerStyledAC = styled(ModalFindDealerStyled)``;
